import { getCoverageLinesText } from '@common/utils';
import { Chip, IconButton, Stack, Tooltip, Typography } from '@common-components';
import { ArrowBackIosNew, FastForward } from '@icons';
import { clearanceOutputConfig } from 'enums/type-mappers/clearance-output-config';
import { triageOutputConfig } from 'enums/type-mappers/triage-output-config';
import { messages } from 'i18n';
import { CarrierSubmission } from 'types';
import { getDotSeparated, getTimezoneLessDisplayDate } from 'utils';

const { header } = messages.carrierSubmissionWorkspace;

interface HeaderProps {
  carrierSubmission: CarrierSubmission;
  onBack: () => void;
}

export default function Header({ carrierSubmission, onBack }: HeaderProps) {
  const { submission, clearanceOutput, triageOutput, stpEnabled } = carrierSubmission;

  const coverageLines = getCoverageLinesText(submission.coverageLines);
  const dueDate = submission.dueDate
    ? messages.submissionWorkspace.header.details.effectiveDate(getTimezoneLessDisplayDate(submission.dueDate))
    : '';

  return (
    <Stack bgcolor="common.white" px={3} width={1} direction="row" alignItems="center" gap={2} py={1.5}>
      <IconButton icon={ArrowBackIosNew} size="small" color="secondary" variant="text" onClick={onBack} />
      <Stack flex={1} minWidth={0}>
        <Stack direction="row" alignItems="center" gap={1}>
          <Typography variant="h4" noWrap>
            {submission.insuredName || header.defaultTitle}
          </Typography>
          {clearanceOutput && (
            <Chip
              size="small"
              color={clearanceOutputConfig[clearanceOutput].color}
              label={clearanceOutputConfig[clearanceOutput].label}
            />
          )}
          {triageOutput && (
            <Chip
              size="small"
              color={triageOutputConfig[triageOutput].color}
              label={triageOutputConfig[triageOutput].label}
            />
          )}
          {stpEnabled && (
            <Tooltip tooltipContent={header.stpActivated}>
              <FastForward color="success" fontSize="small" />
            </Tooltip>
          )}
        </Stack>
        {coverageLines && (
          <Typography variant="body2" color="typography.nonEssential" noWrap>
            {getDotSeparated([coverageLines, dueDate])}
          </Typography>
        )}
      </Stack>
    </Stack>
  );
}
